import * as i0 from '@angular/core';
import { Directive, NgModule } from '@angular/core';

class PlaceHolderDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
PlaceHolderDirective.ɵfac = function PlaceHolderDirective_Factory(t) { return new (t || PlaceHolderDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
PlaceHolderDirective.ɵdir = i0.ɵɵdefineDirective({ type: PlaceHolderDirective, selectors: [["", "dynamicComponentPlaceHolder", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceHolderDirective, [{
        type: Directive,
        args: [{
                selector: '[dynamicComponentPlaceHolder]'
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, null); })();

class PlaceHolderLibraryModule {
}
PlaceHolderLibraryModule.ɵfac = function PlaceHolderLibraryModule_Factory(t) { return new (t || PlaceHolderLibraryModule)(); };
PlaceHolderLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PlaceHolderLibraryModule });
PlaceHolderLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PlaceHolderLibraryModule, { declarations: [PlaceHolderDirective], exports: [PlaceHolderDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceHolderLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [PlaceHolderDirective],
                imports: [],
                providers: [],
                exports: [PlaceHolderDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of place-holder-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PlaceHolderDirective, PlaceHolderLibraryModule };
//# sourceMappingURL=place-holder-library.js.map
